import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  getTheme,
  Text,
} from '@conexasaude/conexa-hero'
import { Icon } from '@conexasaude/iconography/icons'
import { memo } from 'react'
import { PreScheduleCardProps } from './PreScheduleCard.types'
import { usePreScheduleCard } from './PreScheduleCard.hook'
import { RenderIf } from '@/components/RenderIf'

export const PreScheduleCard = memo((props: PreScheduleCardProps) => {
  const { professional } = props
  const { data, actions, validations } = usePreScheduleCard(props)
  const theme = getTheme()

  return (
    <Box>
      <Flex gap={theme.spacing.xxs}>
        <Avatar src={professional?.photo} size={32} />
        <Flex direction="column">
          <Text variant="subheading" ellipsis color={theme.colors.pure.black}>
            {professional.name}
          </Text>
          <Text variant="microCopy" color={theme.colors.neutral[300]} ellipsis>
            {professional.specialty}
          </Text>
        </Flex>
      </Flex>

      <Divider margin="xs" />

      <RenderIf condition={!!data.tag?.label}>
        <Box
          background={data.tag?.background}
          spacing="x-small"
          width="fit-content"
          borderless
        >
          <Text variant="label" color={data.tag?.color}>
            {data.tag?.label}
          </Text>
        </Box>
      </RenderIf>

      <Flex mt={theme.spacing.xs} gap={theme.spacing.xxs}>
        <Icon name="calendar" color={theme.colors.neutral[200]} />

        <Flex gap={theme.spacing.xxs}>
          <Text variant="paragraphSmall" color={theme.colors.neutral[300]}>
            {data.preSchedule.dayOfWeek}
          </Text>
          <Text
            variant="paragraphSmall"
            renderAs="span"
            color={theme.colors.brand.primary[200]}
          >
            •
          </Text>
          <Text variant="paragraphSmall" color={theme.colors.neutral[300]}>
            {data.preSchedule.date}
          </Text>
          <Text
            variant="paragraphSmall"
            renderAs="span"
            color={theme.colors.brand.primary[200]}
          >
            •
          </Text>
          <Text variant="paragraphSmall" color={theme.colors.neutral[300]}>
            {data.preSchedule.time}
          </Text>
        </Flex>
      </Flex>

      <RenderIf condition={!validations.shouldDisableActions}>
        <Flex
          justify="space-between"
          mt={theme.spacing.xs}
          gap={theme.spacing.xxs}
        >
          <Button mode="text" onClick={actions.handleCancelPreSchedule}>
            Cancelar
          </Button>
          <Button onClick={actions.handleConfirmPreSchedule}>Confirmar</Button>
        </Flex>
      </RenderIf>
    </Box>
  )
})

PreScheduleCard.displayName = 'PreScheduleCard'
